<ng-template cdkPortal #dialogPortal="cdkPortal">
  <div class="anchor-dialog bg-white p-3"><ng-content></ng-content></div>
</ng-template>
